const elk_Logger = require('@wps/wps_elk_logger');

const Logger = elk_Logger.createLogger({
  name: 'learning.fe.service',
});

/**
 *
 * @param {*} error
 * @param {*} extra
    errReqUrl  出错接口请求地址
    errParams  出错接口参数
    message    错误文本信息
 */
function LoggerError(error, extra = {
}) {
  Logger.error({
    req: error.request,
    res: error.response,
    err: error.message,
    args: {
      ...extra
    }
  }, extra.message);
}

function LoggerInfo(message, module = '') {
  Logger.info({
    args: {
      message
    }
  }, module);
}

export {
  Logger,
  LoggerError,
  LoggerInfo
};
